export default [
    {
        code: '1',
        name: 'Territory 1'
    },
    {
        code: '2',
        name: 'Territory 2'
    },
    {
        code: '3',
        name: 'Territory 3'
    },
    {
        code: '4',
        name: 'Territory 4'
    }
]